import styled from '@emotion/styled/macro';

/** Icon and label inside the Upload button. */
export const ButtonContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
`;
